<template>
  <div class="page-content">
    <p class="newMine_pageTitle">日志详情</p>
    <div class="newMine_content">
      <div class="content-title">
        <!-- <h3 class="title">{{ notices.title }}</h3> -->
        <div class="d-flex d-flex-center">
          <p class="name">{{ notices.creator }}</p>
          <p class="time">{{ notices.createTime }}</p>
        </div>
      </div>
      <div class="content-explain">
        <div v-html="notices.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  components: {
  },
  name: "newsDetails",
  data () {
    return {
      loading: false,
      notices: {}
    };
  },
  computed: {
    ...mapState(['user'])
  },
  created () {
    console.log(this.$route.query);
    this.notices = JSON.parse(this.$route.query.notices)
    return
    this.getData();
  },
  methods: {
    async getData () {
      this.$http.get('/student/pc/getSchoolInspectorDetail',{id:this.$route.query.id}).then(res=>{
        this.notices=res
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.newMine_content {
  padding: 0 30px;
}

.content-title {
  padding: 30px 0 0 0;
  margin-bottom: 30px;
  font-size: 16px;

  .title {
    font-weight: 400;
    color: #333333;
    text-align: center;
  }

  .name {
    font-weight: 400;
    margin-right: 30px;
  }

  .time {
    font-weight: 400;
  }
}

.content-explain {
  line-height: 35px;
  margin: 5px;
  ::v-deep img{
    max-width: 100%;
  }
}
</style>
